// extracted by mini-css-extract-plugin
export default {"Search":"Home_Search__VANM8"};